import { render, staticRenderFns } from "./CodeDialog.vue?vue&type=template&id=5ef50105&scoped=true&"
import script from "./CodeDialog.vue?vue&type=script&lang=js&"
export * from "./CodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./CodeDialog.vue?vue&type=style&index=0&id=5ef50105&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef50105",
  null
  
)

export default component.exports